<div class="chip d-flex justify-content-between align-items-center gap-2">
  <ng-content select="[chip-icon]"></ng-content>
  <ng-content></ng-content>
</div>
